import type { Order } from "../../../../../../../services";
import type { DateFns } from "../../../../../../../utils/DateFns";

const cellProcessing = (
	item: Order.Model["createdAt"],
	dateFns: DateFns,
): string =>
	dateFns.formatTime2(item, "dd-MM-yyyy", { timezone: dateFns.timezone });

export default cellProcessing;
